import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unselected",
  "use": "icon-unselected-usage",
  "viewBox": "0 0 16.92 16.92",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.92 16.92\" id=\"icon-unselected\">\n  <metadata>\n<x:xmpmeta xmlns:x=\"adobe:ns:meta/\" x:xmptk=\"Adobe XMP Core 5.6-c142 79.160924, 2017/07/13-01:06:39        \">\n   <rdf:RDF xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\">\n      <rdf:Description rdf:about=\"\"></rdf:Description>\n   </rdf:RDF>\n</x:xmpmeta>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</metadata>\n<defs>\n    <style>\n      #icon-unselected .cls-1 {\n        fill: none;\n        stroke-width: 0.92px;\n      }\n    </style>\n  </defs>\n  <rect id=\"icon-unselected_unselected\" class=\"cls-1\" x=\"0.46\" y=\"0.46\" width=\"16\" height=\"16\" rx=\"3\" ry=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/unselected.svg
// module id = bBzy
// module chunks = 24